<template>
  <div>
    <div id="progressBar">
      <div id="progressLine"></div>
      <div id="progressLineCurrentState" v-bind:style="{width:calcProgressWitdh}"></div>
      <div id="progressPointerWrap">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-for="(item, index) in creatProgressArray" :key="index" v-bind:svg-inline="''" v-bind:style="{fill:item.color}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="12"/><circle cx="12" cy="12" r="6" stroke="#fff" stroke-width="4"/></svg>
      </div>
    </div>
    <p id="progressBarChanceMsg">Вероятность одобрения займа {{creatProgressArray[stepCurrent - 1].chance}}%</p>
  </div>
</template>

<script>
export default {
  name: "progressBar",
  props:{
    stepCurrent:{
      type:Number,
      default:0
    },
    stepMax:{
      type:Number,
      default:1
    }
  },
  computed:{
    creatProgressArray(){
      if (this.stepMax === 0) return [];
      let outArr = [];
      for (let i=0; i < this.stepMax; i+=1){
        outArr.push({
          chance : 100 - ( (this.stepMax - (i + 1)) * 5),
          color: (i + 1) <= this.stepCurrent ? 'var(--color-green)' :'var(--color-gray-type1)'
        })
      }
      return outArr;
    },
    calcProgressWitdh(){
      if (this.stepCurrent >= this.stepMax) {
        return '100%'
      }
      if (this.stepMax > 0) {
        return Math.round((100 * this.stepCurrent) / this.stepMax) + '%';
      }
      return '0';
    }
  }
}
</script>

<style scoped>
#progressBar{position: relative;height: var(--font-size-24)}

#progressLine,#progressLineCurrentState{position: absolute;height: var(--font-size-08);left:0;top:calc(50% - (var(--font-size-08) / 2)) }
#progressLine{width:100%;background: var(--color-gray-type1);border-radius: var(--font-size-20);transition: 0.3s ease-out}
#progressLineCurrentState{position: absolute;width: 0;background: var(--color-green);}

#progressPointerWrap{display: flex;align-items: center;justify-content: space-between;position: relative}
#progressPointerWrap svg{width: var(--font-size-24);height: var(--font-size-24);}

#progressBarChanceMsg{color:var(--color-dark-green);margin: var(--font-size-08) 0 var(--font-size-24)}
@media screen and (min-width: 760px) {

}
</style>